export default new class ListToggle {
  constructor() {
    this.classBtnToggle = '.filter-bar__toggle-btn';
    this.classWrapper = '.catalog-list__wrapper';
    this.sClassToggle = 'list';
    this.localStorage = window.localStorage;

    this.callbackView();
    this.handlerClick();
  }

  callbackView() {
    let view = '';

    if (typeof this.localStorage.getItem('view') !== 'undefined') {
      view = this.localStorage.getItem('view');
    }

    if (view) {
      document.querySelector(`${this.classBtnToggle}`).classList.add(view);
      document.querySelector(`${this.classWrapper}`).classList.add(view);
    }

    // console.log(view);
  }

  handlerClick() {
    document.addEventListener('click', (e) => {
      if (!e.target.matches(`${this.classBtnToggle}`)) return;

      this.btn = e.target;

      const obWrapper = document.querySelector(`${this.classWrapper}`);


      if (this.btn.classList.contains(this.sClassToggle)) {
        this.btn.classList.remove(this.sClassToggle);
        obWrapper.classList.remove(this.sClassToggle);

        this.localStorage.setItem('view', '');
      } else {
        this.btn.classList.add(this.sClassToggle);
        obWrapper.classList.add(this.sClassToggle);

        this.localStorage.setItem('view', this.sClassToggle);
      }
    });
  }
}();
